export enum CookieConsentModalActionType {
  COOKIE_CONSENT_MODAL_OPEN = 'COOKIE_CONSENT_MODAL_OPEN',
  COOKIE_CONSENT_MODAL_CLOSE = 'COOKIE_CONSENT_MODAL_CLOSE',
}

export interface CookieConsentModalOpenAction {
  type: CookieConsentModalActionType.COOKIE_CONSENT_MODAL_OPEN;
}
export function openModal(): CookieConsentModalOpenAction {
  return {
    type: CookieConsentModalActionType.COOKIE_CONSENT_MODAL_OPEN,
  };
}

export interface CookieConsentModalCloseAction {
  type: CookieConsentModalActionType.COOKIE_CONSENT_MODAL_CLOSE;
}
export function closeModal(): CookieConsentModalCloseAction {
  return {
    type: CookieConsentModalActionType.COOKIE_CONSENT_MODAL_CLOSE,
  };
}

export type CookieConsentModalAction = CookieConsentModalOpenAction | CookieConsentModalCloseAction;
